const userPoolId = import.meta.env.VITE_USER_POOL_ID ?? 'eu-west-2_WLt91ncjd';
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '2con9vn9pht39gm4ukktt6st9p';
const appsyncEndpoint = import.meta.env.VITE_APPSYNC_ENDPOINT ?? 'https://ct2wt6b74ngoxk5x4qzpkwleza.appsync-api.eu-west-2.amazonaws.com/graphql';
const oauthDomain = import.meta.env.VITE_OAUTH_DOMAIN ?? 'spmockc-devone.auth.eu-west-2.amazoncognito.com';
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';
const redirectSignIn = isLocalhost ? 'http://localhost:5173/callback' : `${origin}/callback`;
const redirectSignOut = isLocalhost ? 'http://localhost:5173' : origin;

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain: oauthDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [redirectSignIn],
          redirectSignOut: [redirectSignOut],
          responseType: 'code' as const,
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: appsyncEndpoint,
      region: 'eu-west-2',
      defaultAuthMode: 'userPool' as const,
    },
  },
};
